export default __webpack_public_path__ + "static/img-4-5d386b2a1eff1dedd845697ba16f8604.png";